import { AuthLayout } from "components";
import { PublicRoute } from "components/HOCs";
import LoginPage from "pages/User/Login";
import RegisterPage from "pages/User/Register";
import { Route } from "react-router-dom";

export const PublicRoutes = () => [
  <Route
    key="register"
    path="register"
    element={
      <PublicRoute layout={AuthLayout}>
        <RegisterPage href="" />
      </PublicRoute>
    }
  />,
  <Route
    key="login"
    path="login"
    element={
      <PublicRoute layout={AuthLayout}>
        <LoginPage href="" />
      </PublicRoute>
    }
  />
];
